/**
 * Created by ed on 2/10/17.
 */
import React, { Component } from 'react';

class AncestorInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onInputChange(this.props.id, this.props.child_id, this.props.side, event.target.value);
    }

    render() {
        return (
            <label className={this.props.side}>
                <span className="label">{this.props.label}:</span>
                <input type="text" className="form-control" id={this.props.id} name={this.props.id} value={this.props.value} onChange={this.handleChange} />
            </label>
        );
    }
}

export default AncestorInput;


// WEBPACK FOOTER //
// ./src/components/AncestorInput.js